<template>
  <div id="slide-bar" class="slide-bar popbox" :class="{show:showSlide}" @click="closeSlideBar()">
    <iframe :src="src" id="user_center"/>
    <div class="opration"></div>
  </div>
</template>
<script>
import store from '../store'
import FN from '../utility/fn.js'
import FUSE from '../fuse/fuse.sdk'
export default {
  data () {
    return {
      src: FN.getSession('SDK_INIT_INFO').hongbao ? FN.getSession('SETTING_URLS').hb : FN.getSession('SETTING_URLS').user,
      // src: '//online-account.lcp.com/v1/personal',
      showSlide: '', // 控制侧边栏是否显示
      showChangePassword: false, // 控制展示修改密码
      showUnbindPhone: false, // 控制解绑手机
      userInfo: FN.getSession('USER_INFO'), // 获取用户信息
      flag: true, // 表单验证标志
      countDown: true, // 控制获取验证码按钮是否可以点击
      count: '', // 显示秒数
      changePasswordForm: {
        mode: 0, // 必填 模式：0:旧密码/1:手机验证码/2:邮箱
        user_id: FN.getSession('USER_INFO').user_id, // 必填 大千用户uid
        new_password: '', // 必填新密码
        old_password: '', // 旧密码，通过旧密码修改时填写
        code: '', // 手机验证码，通过手机验证码找回时填写
        code_sign: '' // 手机验证码签名信息，发送验证码时返回
      },
      PhoneForm: {
        user_id: FN.getSession('USER_INFO').user_id, // 必填 大千用户uid
        phone: FN.getSession('USER_INFO').phone
          ? FN.getSession('USER_INFO').phone
          : '', // string 必填手机号
        code: '', // string 必填手机验证码
        code_sign: '', // string 必填手机验证码签名信息，发送验证码时返回
        code_timeout: '' // int 必填手机验证码过期时间，发送验证码时返回
      }
    }
  },
  mounted () {
    // this.scrollSlide()
    this.showSlideBar()
    document.getElementById("user_center").onload = () => {
      let data = FUSE.getData()
      let roleData = {
        roleId: FN.getSession('ROLE_INFO').roleId,
        roleLevel: FN.getSession('ROLE_INFO').roleLevel,
        roleName: FN.getSession('ROLE_INFO').roleName,
        serverId: FN.getSession('ROLE_INFO').serverId,
        serverName: FN.getSession('ROLE_INFO').serverName
      }
      // 发送给个人中心的参数
      document.getElementById('user_center').contentWindow.postMessage({type: 'getUserInfo', data}, '*')
      document.getElementById('user_center').contentWindow.postMessage({type: 'getRoleInfo', roleData}, '*')
    }
    this.listenChildren()
  },
  methods: {
    // 关闭侧边栏
    closeSlideBar () {
      this.showSlide = false
      setTimeout(() => {
        this.$store.dispatch('SET_SDK_COMPONENT_SLIDEBAR', '')
      }, 300)
    },
    // 展示侧边栏
    showSlideBar () {
      setTimeout(() => {
        this.showSlide = true
      }, 1)
    },
    // SDK内部切换账号
    changeAccountBySdk () {
      // 通知游戏iframe，退出登录。此处没有做清理数据的操作 后续在做
      FN.post({
        type: 'CCF',
        payload: {event: "flymeChangeAccount", statusCode: 0, status: '外部执行切换账户'}
      })
      this.closeSlideBar()
      // 浮标隐藏r
      this.$store.dispatch('SET_SDK_COMPONENT_FLOATBALL', '')
    },
    // 更新手机号码
    UpdateMobile(phone) {
      let userInfo = FN.getSession('USER_INFO')
      userInfo.phone = phone
      FN.saveSession('USER_INFO', userInfo)
      FN.saveLocal('USER_INFO', userInfo)
    },
    // 更新密码
    UpdatePassword(password) {
      let USER_INFO = FN.getSession('USER_INFO')
      let LOGIN_RECORD = FN.getLocal('LOGIN_RECORD')
      USER_INFO.password = password
      LOGIN_RECORD.map(item => {
        if (item.name === USER_INFO.name) {
          item.password = password
        }
      })
      FN.saveLocal('LOGIN_RECORD', LOGIN_RECORD)
      FN.saveSession('USER_INFO', USER_INFO)
      FN.saveLocal('USER_INFO', USER_INFO)
    },
    // 更新实名状态
    updaterealNameStatus(status) {
      let USER_INFO = FN.getSession('USER_INFO')
      USER_INFO.real_name_status = status
      FN.saveSession('USER_INFO', USER_INFO)
      FN.saveLocal('USER_INFO', USER_INFO)
    },
    // 更新会员信息
    updateMemberInfo(info) {
      const USER_INFO = FN.getSession('USER_INFO')
      let LOGIN_RECORD = FN.getLocal('LOGIN_RECORD')
      LOGIN_RECORD[0] = {
        account: info.account, // 用于展示的帐号名， 帐号登录时 account == name， 手机登录时 account == phone
        name: info.account, // 实际登录时都是使用 name 和 password
        password: info.password
      }
      USER_INFO.name = info.account
      USER_INFO.password = info.password
      USER_INFO.login_type = 2
      USER_INFO.is_bind = '1'
      FN.saveLocal('LOGIN_RECORD', LOGIN_RECORD)
      FN.saveSession('USER_INFO', USER_INFO)
      FN.saveLocal('USER_INFO', USER_INFO)
    },
    service() {
      store.dispatch('SET_SDK_COMPONENT_KEFU', 'kefu')
    },
    // 监听个人中心发送回来的方法
    listenChildren(callback) {
      window.addEventListener(
        'message',
        event => {
          if (event.data.type === 'user_center') {
            switch (event.data.data.method) {
              case 'changeAccount':
                this.changeAccountBySdk()
                break;
              case 'UpdateMobile':
                this.UpdateMobile(event.data.data.phone)
                break;
              case 'UpdatePassword':
                this.UpdatePassword(event.data.data.password)
                break;
              case 'updaterealNameStatus':
                this.updaterealNameStatus(event.data.data.status)
                break;
              case 'updateMemberInfo':
                this.updateMemberInfo(event.data.data.data)
                break;
              case 'service':
                this.service(event.data.data.status)
                break;
              case 'close':
                this.closeSlideBar()
                break;
              default:
                break;
            }
          }
        },
        false
      )
    }
  },
  directives: {
    fixedInput: {
      inserted(el, binding) {
        FN.log(el)
        const windowHeight = window.innerHeight
        el.addEventListener('blur', function () {
          let windowFocusHeight = window.innerHeight
          if (windowHeight === windowFocusHeight) {
            return
          }
          FN.log(windowHeight + '--' + windowFocusHeight);
          FN.log('修复');
          let currentPosition;
          let speed = 1; // 页面滚动距离
          currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
          currentPosition -= speed;
          window.scrollTo(0, currentPosition); // 页面向上滚动
          currentPosition += speed; // speed变量
          window.scrollTo(0, currentPosition); // 页面向下滚动
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/css/slide-bar.scss';
#user_center{
  width:88%;
  height:100%;
  position: fixed;
  left: 0;
  top:0;
  background: #fff;
  border:none;
}
</style>
